<template>
  <div class="calendar-entry-form">
    <div class="calendar-entry-sidebar-field">
      <div class="sidebar-field-header" @click="toggleEmployeeInfo">
        {{ editing.number }} - {{ editing.employeeName }}
        <div class="employee-info__icon">
          <span>i</span>
        </div>
      </div>
      <div :class="['sidebar-field__employee-info', employeeInfoOpen && 'sidebar-field__employee-info--visible']" v-on-clickaway="closeEmployeeInfo">
        <div v-if="employeeInfoRows.length > 0" class="employee-info__fields">
          <div class="employee-info__field" v-for="(row, index) of employeeInfoRows" :key="index">
            <span class="employee-info__label">
              {{ row.label }}
            </span>
            <span class="employee-info__text">
              {{ row.text }}
            </span>
          </div>
        </div>
        <div v-else class="employee-info__fields">
          <span class="employee-info__noInfo">
            Ingen kontaktinformation
          </span>
        </div>
      </div>
    </div>
    <div class="calendar-entry-sidebar-field">
      <div class="sidebar-field-label">Fra dato</div>
      <div class="sidebar-field-input">
        <b-datepicker v-model="startDateComputed" :focusedDate="startDateComputed" @input="modelUpdated" locale="da-DK" expanded :disabled="readonly && !editing.isSimulation" placeholder="Vælg en fra-dato"> </b-datepicker>
      </div>
    </div>
    <div class="calendar-entry-sidebar-field" v-if="editing.allocationType !== 'OFFDAYREPLACEMENT'">
      <div class="sidebar-field-label">Til dato</div>
      <div class="sidebar-field-input">
        <b-datepicker v-model="endDateComputed" :focusedDate="endDateComputed" @input="modelUpdated" locale="da-DK" expanded :disabled="readonly && !editing.isSimulation" placeholder="Vælg en til-dato"> </b-datepicker>
      </div>
    </div>
    <div class="calendar-entry-sidebar-field" v-if="notification && isAdmin">
      <div class="sidebar-field-label">Udsæt indtil</div>
      <div class="sidebar-field-input">
        <b-datepicker v-model="onHoldUntilDateComputed" :focusedDate="onHoldUntilDateComputed" @input="modelUpdated" locale="da-DK" expanded :disabled="readonly" placeholder="Vælg en udsæt indtil-dato"> </b-datepicker>
      </div>
    </div>
    <div class="calendar-entry-sidebar-field" v-if="editing.allocationType !== undefined && editing.allocationType !== 'OFFDAYREPLACEMENT'">
      <div class="sidebar-field-label">Type</div>
      <div class="sidebar-field-input">
        <b-select v-model="editing.allocationType" expanded :disabled="typeDisabled" @input="modelUpdated">
          <option v-for="item in availableAllocationTypes" :key="item.key" :value="item.key">
            {{ item.label }}
          </option>
        </b-select>
      </div>
    </div>
    <div class="calendar-entry-sidebar-field" v-if="isAdmin && !notification && editing.circleId && avalilableCircles.length > 1">
      <div class="sidebar-field-label">Kreds</div>
      <div class="sidebar-field-input">
        <b-select v-model="editing.circleId" expanded :disabled="readonly" @input="modelUpdated">
          <option v-for="(circle, index) in avalilableCircles" :key="index" :value="circle.id">
            {{ circle.title }}
          </option>
        </b-select>
      </div>
    </div>

    <div v-if="editing.allocationSpanInDays > 1 && !editing.replacementId && !editing.isSimulation">
      <div class="calendar-entry-sidebar-field" v-if="!isReplacement && isVisible">
        <div class="sidebar-field-label"></div>
        <div class="sidebar-field-input">
          <div>
            <b-button @click="onRequestSplit" class="is-gray">Split</b-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="editing.allocationSpanInDays > 1 && editing.isSimulation">
      <div class="calendar-entry-sidebar-field">
        <div class="sidebar-field-label">Split</div>
        <div class="sidebar-field-input">
          <b-checkbox size="is-medium" v-model="splitComputed" @input="modelUpdated"></b-checkbox>
        </div>
      </div>
    </div>

    <div v-if="(editing.allocationSpanInDays <= 1 || editing.replacementId) && !editing.isSimulation">
      <div class="calendar-entry-sidebar-field" v-if="!isReplacement && editing.allocationType !== 'OFFDAYREPLACEMENT' && !editing.replacementId && isVisible">
        <div class="sidebar-field-label">Overfør Til</div>
        <div class="sidebar-field-input">
          <b-select v-model="editing.transferTo" expanded :disabled="readonly" @input="modelUpdated">
            <option v-for="(employee, index) in availableEmployees" :key="index" :value="employee.id">
              {{ employee.number }} - {{ employee.name }} -
              {{ employee.region }}
            </option>
          </b-select>
        </div>
      </div>
      <div class="calendar-entry-sidebar-field" v-if="isAdmin && editing.circleId && !editing.isSimulation">
        <div class="sidebar-field-label afloes">Afløst af</div>
        <div class="sidebar-field-input dropDown">
          <div class="dropDownBtn" @click="showDropDown(true)">
            <b-input class="selectedLine" style="display:none;" v-if="selectedReplaceStatus" v-model="selectedReplacement.number" expanded :disabled="readonly" @input="modelUpdated"></b-input>
            <div class="selectedLine" v-if="getReplacement">
              <div>{{ getReplacement.number }} </div>
              <div>- {{ getReplacement.name }} </div>
              <div style="margin-left: 5px;" v-if="getReplacement.role || getReplacement.region || getReplacement.groupName">- {{ getReplacement.role === "Replacement" ? getReplacement.region : getReplacement.groupName }}</div>
            </div>
          </div>
          <div class="dropDownContent" id="dropDown" v-if="dropDownStatus" style="display: block;">
            <div class="selectLine" v-for="(employee, index) in replacements" :key="index" :value="employee.id" @click="selectReplacement(employee)">
              <div class="employeeInfos">
                <div v-if="!employee.isOpenForGroup" class="dot normal"></div>
                <div v-if="employee.isOpenForGroup" class="dot special"></div>
                <div v-if="employee.number">
                  <p>{{ employee.number }}</p>
                </div>
                <div v-if="employee.name">
                  <div v-if="employee.name.length > 10">
                    <p>- {{ employee.name.substring(0, 10) + "..." }} -</p>
                  </div>
                  <div v-else>
                    <p>- {{ employee.name }} -</p>
                  </div>
                </div>
              </div>
              <div style="width: 30px; margin-top: 3px; text-align: right;" v-if="employee.role || employee.region || employee.groupName">
                <p>{{ employee.role === "Replacement" ? employee.region : employee.groupName }}</p>
              </div>
              <div class="employeeDayRow">
                <div class="dayRow" v-for="(availability, index) in employee.availability" :key="index">
                  <div v-if="index < 4">
                    <div v-if="availability == 'F'" class="dot lastfrieDays"></div>
                    <div v-else class="lastWorkDays">{{ availability }}</div>
                  </div>
                  <div v-if="index == 5">
                    <div v-if="availability === 'F'" class="frieDay-border">
                      <div class="today">
                        {{ today }}
                      </div>
                    </div>
                    <div v-else class="workDay-border">
                      <div class="today">{{ availability }}</div>                      
                    </div>
                  </div>
                  <div v-if="index > 5">
                    <div v-if="availability == 'F'" class="dot futureFrieDays"></div>
                    <div v-else class="futureWorkDays">{{ availability }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="calendar-entry-sidebar-field" v-if="isAdmin && editing.circleId && editing.replacementId && !editing.isSimulation">
        <div class="sidebar-field-label">Bookede afl.</div>
        <div class="sidebar-field-input">
          <b-select v-model="editing.bookedAllocationId" expanded :disabled="readonly" @input="modelUpdated">
            <option v-for="(employee, index) in bookedReplacements" :key="index" :value="employee.allocation.id">
              {{ employee.number }} - {{ employee.name }} -
              {{ employee.role === "Replacement" ? employee.circleName : "" }}
            </option>
          </b-select>
        </div>
      </div>
      <div class="calendar-entry-sidebar-field" v-if="isAdmin && editing.circleId && editing.replacementId && !editing.isSimulation">
        <div class="sidebar-field-label">Tilknyt ny opg.</div>
        <div class="sidebar-field-input">
          <b-select v-model="editing.attachNewAllocation" expanded :disabled="readonly" @input="modelUpdated">
            <option v-for="(circle, index) in circlesWithoutOverallocations" :key="index" :value="circle.id">
              {{ circle.title }}
            </option>
          </b-select>
        </div>
      </div>

      <div class="calendar-entry-sidebar-field" v-if="!isReplacement && !editing.replacementId && isVisible && !editing.isSimulation">
        <div class="sidebar-field-label">Afløser</div>
        <div class="sidebar-field-input" v-if="editing.allocationSpanInDays <= 1">
          <div v-if="!notification">
            <b-button @click="onRequestReplacement" class="is-gray">Anmod afløser</b-button>
            <span v-if="replacements.length > 1" class="free-replacement-label" @click="onViewReplacement">(ledige {{ replacements.length - 1 }})</span>
          </div>
          <div v-if="notification">
            <b-button @click="onRequestReplacementRemove" class="is-gray">Fjern anmodning</b-button>
            <span class="sidebar-label" @click="onRequestReplacementRemove">{{ notificationLabel() }}</span>
          </div>
        </div>
        <div class="sidebar-field-input" v-if="editing.allocationSpanInDays > 1">
          <span class="sidebar-label">Kan ikke anmode om afløser da denne opgave strækker sig over flere dage.</span>
        </div>
      </div>

      <div class="calendar-entry-sidebar-field" v-if="editing.replacementId && editing.replacementName && !isAdmin && !editing.isSimulation">
        <div class="sidebar-field-label" v-if="showReplacement">Afløst af.</div>
        <div class="sidebar-field-input" v-if="showReplacement">
          <b-input v-model="editing.replacementName" expanded :disabled="readonly" />
        </div>
        <div class="sidebar-field-label" v-if="!showReplacement">Afløser</div>
        <div class="sidebar-field-input" v-if="!showReplacement">
          <b-input v-model="editing.employeeName" expanded :disabled="readonly" />
        </div>
      </div>
    </div>
    <div class="calendar-entry-sidebar-field" v-if="isAdmin && !editing.isSimulation">
      <div class="sidebar-field-label">Dage ins.</div>
      <div class="sidebar-field-input">
        <b-checkbox title="Afkrydset dette felt så auto beregnes dage ins. ikke" size="is-medium" v-model="dayTypeComputed" @input="modelUpdated"></b-checkbox>
        <b-numberinput v-model="editing.days" step="0.01" :controls="false" @input="modelUpdated" :disabled="readonly" />
      </div>
    </div>

    <div class="calendar-entry-sidebar-field" v-if="isAdmin && editing.replacementId && !editing.isSimulation">
      <div class="sidebar-field-label">Dage afl.</div>
      <div class="sidebar-field-input">
        <b-checkbox title="Afkrydset dette felt så auto beregnes dage afl. ikke" size="is-medium" v-model="daysReplacementTypeComputed" @input="modelUpdated"></b-checkbox>
        <b-numberinput v-model="editing.daysReplacement" step="0.01" :controls="false" @input="modelUpdated" :disabled="readonly" />
      </div>
    </div>

    <div class="calendar-entry-sidebar-field">
      <div class="sidebar-field-label">Besked</div>
      <div class="sidebar-field-input">
        <b-input v-model="editing.comment" @input="modelUpdated" type="textarea" maxlength="256" :disabled="readonly && !editing.isSimulation"></b-input>
      </div>
    </div>
    <div class="calendar-entry-sidebar-field" v-if="isVisible && !editing.isSimulation">
      <div class="sidebar-field-label">Bemærkninger</div>
      <div class="sidebar-field-input">
        <b-input v-model="editing.note" @input="modelUpdated" type="textarea" maxlength="256" :disabled="readonly"></b-input>
      </div>
    </div>
    <div class="calendar-entry-sidebar-field" v-if="isVisible && !editing.isSimulation">
      <div class="sidebar-field-label">Note til kontor</div>
      <div class="sidebar-field-input">
        <b-input v-model="editing.officeNote" @input="modelUpdated" type="textarea" maxlength="256" :disabled="readonly"></b-input>
      </div>
    </div>
    <div class="calendar-entry-sidebar-field" v-if="isAdmin && hasEditRights && !editing.isSimulation">
      <div class="sidebar-field-label">Admin note</div>
      <div class="sidebar-field-input">
        <b-input v-model="editing.adminNote" @input="modelUpdated" type="textarea" maxlength="256" :disabled="readonly"></b-input>
      </div>
    </div>
    <div class="calendar-entry-sidebar-spacer"></div>
    <div class="calendar-entry-sidebar-field" v-if="isAdmin && hasEditRights">
      <div class="sidebar-field-label">Notifikation</div>
      <div class="sidebar-field-input">
        <b-select v-model="editing.emailTarget" @input="modelUpdated" expanded :disabled="readonly">
          <option value="">Ingen får besked</option>
          <option value="1">Send e-mail til ins.</option>
          <option value="2">Send e-mail til involverede</option>
        </b-select>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import ApiState from "../../enums/APISTATE";
  import moment, { ISO_8601 } from "moment";
  import { mixin as clickaway } from "vue-clickaway";
  import _ from "lodash";
  import Vue from "vue";

  const selectorReducer = (previousValue, currentValue) => previousValue[currentValue];

  export default {
    name: "calendar-entry-form",
    mixins: [clickaway],
    props: {
      value: {
        type: Object,
        default: () => ({}),
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      selectedReplaceStatus: false,
      dropDownStatus: false,
      today: '',
      dotType: null,
      toDate: new Date(),
      region: null,
      editing: {},
      selectedReplacement: {},
      employeeInfoOpen: false,
      employeeInfoClosable: false,
      employeeInfoFields: [
        { selector: ["value", "employee", "address"], label: "Adresse" },
        { selector: ["value", "employee", "email"], label: "Email" },
        { selector: ["value", "employee", "mobilPhone"], label: "Mobiltelefon" },
        { selector: ["value", "employee", "phoneWork"], label: "Arbejdstelefon" },
      ],
      replacementAllocationTypes: ["VACATION", "OFFDAY"],
    }),
    async mounted() {
      await this.$store.dispatch("metadata/initialize");
      await this.loadAvailableEmployees(this.value.startDate);
      await this.loadAllCircles();
      await this.loadAvailableCircle();
      if (localStorage.regionFilter) {
        this.region = localStorage.regionFilter === "null" ? null : localStorage.regionFilter;
      }

      if (this.value !== undefined) {
        this.editing = { ...this.value };
        this.editing["emailTarget"] = ""; // Replace with real value from backend
      }
      const dayNow = new Date();
      this.today = dayNow.toLocaleDateString('da-DK', { weekday: "short" });
    },
    methods: {
      ...mapActions("employees", ["loadReplacementsFromDate", "getAvailableEmployees", "loadEmployees"]),
      ...mapActions("notificationStore", ["getNotificationFromAllocation", "setNotificationOnStore"]),
      ...mapActions("circles", ["loadAllCircles", "getCircleForGroup"]),
      createNew() {
        this.$set(this, "editing", {});
      },
      modelUpdated() {
        this.$nextTick(() => {
          if (this.editing && this.editing.id) {
            this.$emit("onChange", this.editing);
            console.log('nextTick...', this.editing)
          }
          if (this.notification) {
            if (this.notification.state <= 1) {
              this.notification.state = this.notification.onHoldUntilDate ? 1 : 0;
            }

            this.setNotificationOnStore(this.notification);
          }
        });
      },
      onRequestReplacement(arg) {
        this.$emit("onRequestReplacement", this.editing);
      },
      onRequestReplacementRemove(arg) {
        if (this.notification) {
          this.$emit("onRequestReplacementRemove", this.notification);
        }
      },
      onRequestSplit(arg) {
        this.$emit("onRequestSplit", this.editing);
      },
      onViewReplacement() {
        this.$emit("onViewReplacement");
      },
      notificationLabel() {
        if (this.notification) {
          if (this.notification.state === 0) {
            return "Afsendt anmodning";
          }

          if (this.notification.state === 1) {
            return "Anmodning afventer";
          }

          if (this.notification.state === 3) {
            return "Anmodning afvist";
          }
        }
        return "";
      },
      toggleEmployeeInfo() {
        this.employeeInfoOpen = !this.employeeInfoOpen;
        if (this.employeeInfoOpen) {
          _.debounce(() => {
            this.employeeInfoClosable = true;
          }, 250)();
        }
      },
      closeEmployeeInfo() {
        if (this.employeeInfoClosable) {
          this.employeeInfoOpen = false;
        }
      },
      getSelectorValue(selector) {
        const value = selector.reduce(selectorReducer, this);
        return value ? value : "";
      },
      showSelector(selector) {
        return this.getSelectorValue(selector) !== "";
      },
      async loadAvailableEmployees(forDate) {
        if (!this.value || !this.value.employee) {
          return;
        }
        let groupId = this.value.employee.groupId;
        if (localStorage.groupFilter && localStorage.groupFilter !== "null") {
          groupId = localStorage.groupFilter === "null" ? this.value.employee.groupId : localStorage.groupFilter;
        }

        await this.getAvailableEmployees({ forGroup: groupId, forDate: forDate });
      },
      async loadAvailableCircle() {
        if (!this.editing || !this.editing.employee) {
          return;
        }
        let groupId = this.editing.employee.groupId;
        if (localStorage.groupFilter && localStorage.groupFilter !== "null") {
          groupId = localStorage.groupFilter === "null" ? groupId : localStorage.groupFilter;
        }

        await this.getCircleForGroup({ groupId: groupId });
      },
      formatAvailability(employee) {
        if (Array.isArray(employee.availability) && employee.availability.length >= 2) {
          const middle = Math.floor(employee.availability.length / 2);
          const first = employee.availability.slice(0, middle);
          const second = employee.availability.slice(middle + 1);
          return `${first.join(", ")} / ${employee.availability[middle]} / ${second.join(", ")}`;
        }
        return "";
      },

      selectReplacement(selectedEmployee) {        
        this.selectedReplacement = selectedEmployee;
        this.selectedReplaceStatus = true;
        this.showDropDown(this.dropDownStatus);
        this.editing.replacementId = this.selectedReplacement.id;
        this.$emit("onChange", this.editing);

        return this.editing.replacementId;
      },
      showDropDown(dropDownStatus) {
        console.log(dropDownStatus);
        this.dropDownStatus = !this.dropDownStatus;
      },
    },
    computed: {
      ...mapGetters("employees", ["replacementsForDate", "replacementsForDateApiState", "availableEmployees"]),
      ...mapGetters("notificationStore", ["notification", "notifications", "notificationApiState"]),
      ...mapGetters("metadata", ["allocationTypes", "allocationTypesReport"]),
      ...mapGetters(["currentUser", "isAdmin", "isReplacement", "hasEditRights"]),
      ...mapGetters("circles", ["circleApiState", "circles", "circlesForGroup"]),
      isCurrentUser() {
        if (!this.editing) {
          return false;
        }

        return this.currentUser.id === this.editing.employeeId;
      },
      isReadOnly() {
        return this.readonly || (this.editing && this.editing.isReadOnly);
      },
      isVisible() {
        let show = this.hasEditRights;
        if (this.editing) {
          show &= this.editing.isReadOnly === false;
        }
        return show;
      },
      typeDisabled() {
        if (this.isReplacement && this.isCurrentUser && this.replacementAllocationTypes.includes(this.editing.allocationType)) {
          // Replacement users can edit the allocation type, if the allocation is theirs
          // and the type is 'vacation' or 'dayoff'
          return false;
        }
        return this.readonly;
      },
      showReplacement() {
        if (!this.editing) {
          return false;
        }

        if (this.editing.isReadOnly && this.isReplacement === false) {
          return true;
        }
        return this.currentUser.id === this.editing.employeeId || (this.editing.replacementId && this.currentUser.id !== this.editing.replacementId);
      },
      availableAllocationTypes() {
        if (!this.editing) {
          return [];
        }

        if (!this.allocationTypesReport) {
          return [];
        }
        if (this.isReplacement && this.isCurrentUser && this.replacementAllocationTypes.includes(this.editing.allocationType)) {
          // Replacement users see a limited selection of allocation types, in the case
          // where the allocation they're editing is theirs and the entry's allocation
          // type is within the limited selection.
          return this.allocationTypesReport.filter((q) => this.replacementAllocationTypes.includes(q.key));
        }
        return this.allocationTypesReport.filter((o) => o.isVisible);
      },
      dayTypeComputed: {
        get() {
          return this.editing.daysType === 0 ? false : true;
        },
        set(value) {
          if (value) {
            this.editing.daysType = 1;
          } else {
            this.editing.daysType = 0;
          }
        },
      },
      daysReplacementTypeComputed: {
        get() {
          return this.editing.daysReplacementType === 0 ? false : true;
        },
        set(value) {
          if (value) {
            this.editing.daysReplacementType = 1;
          } else {
            this.editing.daysReplacementType = 0;
          }
        },
      },
      splitComputed: {
        get() {
          return this.editing.split ? true : false;
        },
        set(value) {
          this.editing.split = value;
        },
      },
      startDateComputed: {
        get() {
          return new Date(this.editing.startDate);
        },
        set(value) {
          this.editing.startDate = moment(value).format("YYYY-MM-DD");
          var a = moment(this.editing.startDate);
          var b = moment(this.editing.endDateInclusive);
          this.editing.allocationSpanInDays = b.diff(a, "days") + 1; // =1
        },
      },
      endDateComputed: {
        get() {
          return new Date(this.editing.endDateInclusive);
        },
        set(value) {
          this.editing.endDateInclusive = moment(value).format("YYYY-MM-DD");

          var a = moment(this.editing.startDate);
          var b = moment(this.editing.endDateInclusive);
          this.editing.allocationSpanInDays = b.diff(a, "days") + 1; // =1
        },
      },
      onHoldUntilDateComputed: {
        get() {
          return this.notification.onHoldUntilDate ? new Date(this.notification.onHoldUntilDate) : null;
        },
        set(value) {
          if (!value) {
            this.notification.onHoldUntilDate = null;
          } else {
            this.notification.onHoldUntilDate = moment(value).format("YYYY-MM-DD");
          }
        },
      },
      loading() {
        return this.replacementsForDateApiState !== ApiState.LOADED && this.notificationApiState !== ApiState.LOADED;
      },
      avalilableCircles() {
        return this.circlesForGroup;
      },
      replacements() {
        let result = [];
        if (this.replacementsForDate) {
          result = this.replacementsForDate.filter((o) => o.id === this.editing.replacementId || (o.replacements?.some((r) => r.circle?.groupId === this.editing.circle?.groupId) && o.replacements.filter((r) => r.circle?.groupId === this.editing.circle?.groupId).length < 2) || (!o.allocation && (this.editing.region === "begge" || this.editing.region === o.region || o.region === "begge")));
          if (this.availableEmployees) {
            for (let item of this.availableEmployees) {
              if (result.some((q) => q.id === item.id)) {
                continue;
              }

              if (item.role === "NA") {
                continue;
              }
              result.push(item);
            }
          }
          result.unshift({
            name: "Ingen afløser",
            number: 0,
            region: "",
            id: null,
            isActive: true,
          });
        }

        if (this.editing.replacementId && !result.find((res) => res.id == this.editing.replacementId)) {
          result.unshift({
            name: this.editing.replacementName,
            number: this.editing.replacementNumber,
            region: this.editing.region,
            id: this.editing.replacementId,
            isActive: true,
          });
        }
        let filteredResult = result.filter((res) => res.isActive || res.id == this.editing.replacementId);
        return filteredResult;
      },
      canGroupReplace() {
        return (
          true ||
          this.editing.allocationType === "SICKDAY" ||
          this.editing.allocationType === "SICKDAYCHILD" ||
          this.editing.allocationType === "SICKDAYWORK" ||
          this.editing.allocationType === "MATERNETY" ||
          this.editing.allocationType === "MATERNETYNONPAID" ||
          this.editing.allocationType === "TIMEOFF" ||
          this.editing.allocationType === "FUNERAL" ||
          this.editing.allocationType === "VACATION" ||
          this.editing.allocationType === "ABSENCE"
        );
      },
      bookedReplacements() {
        if (this.replacementsForDate) {
          return this.replacementsForDate
            .filter((o) => o.id !== this.editing.replacementId && o.allocation && (this.editing.region === "begge" || this.editing.region === o.region || this.editing.region === "begge"));
        }
        return [];
      },
      employeeInfoRows() {
        if (!this.employeeInfoOpen) {
          return [];
        }

        return this.employeeInfoFields
          .map((q) => {
            return { label: q.label, text: this.getSelectorValue(q.selector) };
          })
          .filter((q) => q.text !== "");
      },
      circlesWithoutOverallocations() {
        return this.circles ? this.circles.filter((q) => q.showOverallocation === false) : [];
      },
      getReplacement() {
        if (this.replacements && this.editing) {
          return this.replacements.find((o) => o.id === this.editing.replacementId);
        }
        return undefined;
      },
    },
    watch: {
      async value(newValue) {
        this.editing = { ...newValue };
        if (localStorage.regionFilter) {
          this.region = localStorage.regionFilter === "null" ? null : localStorage.regionFilter;
        }
        if (this.editing) {
          await this.loadReplacementsFromDate({
            date: this.editing.startDate,
            region: this.region,
          });

          if (!this.editing.replacementId && (!this.notification || this.notification.allocationId !== this.editing.id)) {
            await this.getNotificationFromAllocation(this.editing);
          }
          await this.loadAvailableCircle();
          const dayNow = new Date(this.editing.startDate);
          this.today = dayNow.toLocaleDateString('da-DK', { weekday: "short" });
          this.dropDownStatus = false;
        }
      },
      async "value.startDate"(newValue) {
        await this.loadAvailableEmployees(newValue);
        this.selectedReplacement = "";
      },
    },
  };
</script>

<style lang="scss">
  option::first-letter {
    font-size: 1.5rem;
    font-weight: bold;
    color: brown;
  }

  .afloes {
    margin-top: 10px;
  }

  .dropDown {
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .dropDownBtn {
    background-color: #ffffff;
    border: 1px solid rgb(0, 0, 0);
    color: white;
    height: 30px;
    font-size: 13px;
    font-weight: normal;
    padding-left: 6px;
    padding-top: 5px;
    cursor: pointer;
  }

  .dropDownContent {
    display: none;
    position: absolute;
    margin-top: -1px;
    margin-left: -95px !important;
    background-color: #ffffff;
    border: 0.5px solid rgb(179, 179, 179);
    border-radius: 10px;
    width: 100%;
    box-shadow: 0px 8px 16px 0px rgba(168, 168, 168, 0.2);
    z-index: 10 !important;
    padding: 2px;
  }

  .dropDownContent div {
    height: 25px;
    color: black;
  }

  .selectedLine {
    display: flex;
    flex-direction: row;
    color: black;
    height: 30px;
    padding: 0 !important;
  }

  .selectLine {
    display: flex;
    flex-direction: row;
    flex-shrink: 1;
    height: 30px;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }

  .selectLine:hover {
    background-color: #385fdf;
  }

  .selectLine:hover p {
    color: white !important;
  }

  .employeeInfos:hover {
    color: white !important;
  }

  .employeeInfos {
    flex-grow: 1;
    display: flex;
    justify-content: flex-start;
    padding-top: 3px;
    padding-left: 3px;
  }

  .employeeInfos > div {
    margin-left: 3px;
  }

  .employeeDayRow {
    min-width: 55%;
    padding-top: 3px;
    padding-right: 3px;
    display: flex;
    justify-content: flex-end;
  }

  .dot {
    margin-top: 3.5px !important;
    height: 10px !important;
    width: 10px !important;
    border-radius: 50%;
  }

  .futureFrieDays {
    background-color: rgb(2, 204, 2);
  }

  .special {
    background-color: rgb(2, 46, 204);
  }

  .normal,
  .lastfrieDays {
    background-color: rgb(226, 226, 226);
  }

  .frieDay-border {
    border: solid 2px rgb(2, 204, 2);
    background-color: rgb(226, 226, 226);
    border-radius: 5px;
    height: 19px !important;
    position: relative;
    width: 35px;
  }

  .workDay-border {
    border: solid 2px rgb(85, 85, 85);
    background-color: rgb(226, 226, 226);
    border-radius: 5px;
    height: 19px !important;
    position: relative;
    width: 35px;
  }
  

  .today {
    height: 16px !important;
    
    width: 32px;
    position: absolute;
    top: -1px;
  }

  .lastWorkDays,
  .futureWorkDays {
    width: auto;
    padding-bottom: 2px;
    padding-left: 5px;
    padding-right: 5px;
    height: 17px !important;
    border-radius: 15px;
    background-color: rgb(226, 226, 226);
    font-size: 11px;
  }

  .dayRow > div {
    margin-left: 2px;
    min-width: 10px;
  }

  .b-numberinput input[type="number"] {
    text-align: right !important;
  }

  .free-replacement-label {
    font-size: 13px;
    padding: 6px 8px;
    float: left;
    cursor: pointer;
  }

  .sidebar-label {
    font-size: 13px;
    padding: 6px 8px;
    float: left;
  }

  .calendar-entry-form {
    flex: 2 0 auto;

    display: flex;
    flex-flow: column nowrap;
    font-size: 12px !important;
    gap: 10px;

    .calendar-entry-sidebar-field {
      flex: 0 1 auto;

      display: flex;
      flex-flow: row nowrap;
      position: relative;

      width: 100%;

      .sidebar-field-header {
        flex: 0 0 auto;
        font-size: large;
        font-weight: 700;
        padding: 10px;
        z-index: 6;
        cursor: pointer;

        .employee-info__icon {
          border: 2px solid $blue;
          color: $blue;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;
          z-index: 4;
        }
      }

      .sidebar-field__employee-info {
        visibility: hidden;
        position: absolute;
        top: 5px;
        border: 3px solid $border;
        width: 100%;
        z-index: 5;
        background-color: #f7f7f7;
        padding-top: 40px;
        padding-bottom: 12px;

        transform-origin: top;
        transition: color 0.25s ease-in 0s;

        &.sidebar-field__employee-info--visible {
          visibility: visible;
          -webkit-animation: blind-in 0.25s 1;
          animation: blind-in 0.25s 1;
          transition: color 0.25s ease-in 0s;
        }

        .employee-info__fields {
          display: flex;
          flex-flow: column nowrap;

          .employee-info__field {
            display: flex;
            flex-flow: row nowrap;
            gap: 10px;

            .employee-info__label {
              flex: 0 0 100px;
              text-align: right;
              color: #8d8d8d;
            }

            .employee-info__text {
              flex: 1 1 auto;
              text-align: left;
            }
          }
        }
      }

      .sidebar-field-label {
        flex: 0 0 auto;
        width: 95px;

        color: $black;
        text-align: right;
        padding-top: 7px;
        padding-right: 10px;
      }

      .sidebar-field-input {
        flex: 1 1 auto;

        .datepicker {
          input {
            padding-right: 0;
          }
        }

        .control {
          font-size: 12px !important;
        }

        .textarea {
          font-size: 12px;
          padding: 5px;
          min-height: 6em !important;
        }

        input {
          font-size: inherit;
        }
      }
    }

    .calendar-entry-sidebar-spacer {
      flex: 1 0 auto;
    }
  }

  input {
    border-radius: 0 !important;
  }

  .button.is-gray {
    float: left;
  }

  .is-medium {
    float: left;
    padding-top: 3px;
  }

  .sidebar-field-input > span {
    text-align: left;
    display: inherit;
    padding: 3px 6px;
    font-size: 12px;
    font-weight: bolder;
  }

  [disabled].textarea,
  select[disabled],
  div.is-disabled,
  [disabled].input {
    border-color: rgb(60, 60, 61) !important;
    background: rgb(60, 60, 61, 0.1) !important;
    color: black !important;
  }

  @-webkit-keyframes blind-in {
    0% {
      transform: scaleY(0);
    }

    100% {
      transform: scaleY(1);
    }
  }

  @keyframes blind-in {
    0% {
      transform: scaleY(0);
    }

    100% {
      transform: scaleY(1);
    }
  }
</style>
